import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emSplitString',
  standalone: false,
})
export class SplitStringPipe implements PipeTransform {
  public transform(value: string | undefined, separator: string, index: number): string {
    if (!value) {
      return '';
    }

    return value.split(separator)[index];
  }
}
